import { FC } from "react";
import { useAuth } from "@/data/context/authContext";
import { Navigate } from "react-router-dom";
import ROUTES from "@/data/Routes";
import Loading from "@/components/Loading";

const Results: FC = () => {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading className="mt-20" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return (
    <div className="p-8">
      <h1 className="text-ink text-3xl font-bold">Results</h1>
      <p className="text-muted mt-4">Your test results will appear here.</p>
    </div>
  );
};

export default Results;
